import { API_URL_ARTIST } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getArtists = () =>
  apiInstance({
    url: API_URL_ARTIST,
    params: {
      limit: 5000,
      order: "-1",
      sort: "createdAt",
    },
  });

export default getArtists;
